import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Grid } from '@material-ui/core';

import Accordion from '../../../../components/Accordion';
import Input from '../../../../components/Inputs/Input';

import Button from '../../../../components/Button';
import Select from '../../../../components/Inputs/Select';

import { cloneObject } from '../../../../utils';

import schema from './schema';

import validators from '../../../../utils/defaultValidators';

import { getEnderecoByCep, getEstados, getMunicipios } from '../../../../services';

const addressSchema = {
    estado: {
        sigla: '',
        municipios: [
            {
                nome: '',
                bairros: [
                    {
                        nome: '',
                    },
                ],
            },
        ],
    },
    logradouro: '',
    tipoLogradouro: '',
};

function EditarEndereco({ dataEndereco }) {
    const history = useHistory();

    const [cepLoading, setCepLoading] = useState(false);
    const [alreadySearchedCep, setAlreadySearchedCep] = useState(false);

    const [dataForm, setDataForm] = useState(dataEndereco ? cloneObject(dataEndereco) : cloneObject(schema));

    useEffect(() => {
        async function loadStates() {
            const estados = (await getEstados()) || [];

            setDataForm({
                ...dataForm,
                uf: { ...dataForm.uf, options: estados },
            });
        }

        loadStates();
    }, []);

    function handleInputBlur(event) {
        const { id, name } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        if (['cellphone', 'comercialPhone', 'phone', 'phone2'].includes(key) && form[key].value?.length <= 1) {
            form[key].value = '';
            form[key].unmaskedValue = '';
        }

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (form[key].required || (!form[key].required && !!form[key].value)) {
            if (typeof validators[key] === 'function') validators[key](form);
        }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !form[key].value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeState(state) {
        const municipios = (await getMunicipios(state)) || [];

        return municipios;
    }

    async function handleChangeCep(event) {
        const { value, unmaskedValue } = event;

        setCepLoading(true);
        let foundCep = true;
        const response = (await getEnderecoByCep(unmaskedValue)) || [];

        // Para zerar o endereço caso seja digitado um cep inválido
        if (!response.length) {
            response.push({ ...addressSchema });
            foundCep = false;
        }

        const address = response[0];

        const dataAddress = {
            address: {
                ...dataForm.address,
                value: address.tipoLogradouro ? `${address.tipoLogradouro}. ${address.logradouro}` : '',
            },
            hood: { ...dataForm.hood, value: address.estado.municipios[0].bairros[0].nome },
            uf: { ...dataForm.uf, value: address.estado.sigla, lookup: address.estado.nome },
            city: {
                ...dataForm.city,
                value: address.estado.municipios[0].codigo,
                lookup: address.estado.municipios[0].nome,
            },
            cep: {
                ...dataForm.cep,
                unmaskedValue,
                value,
                error: !foundCep && 'Os dados de endereço não foram localizados a partir do CEP informado',
            },
        };

        if (foundCep) {
            dataAddress.address.error = '';
            dataAddress.hood.error = '';
            dataAddress.uf.error = '';
            dataAddress.city.error = '';
        }

        setCepLoading(false);
        setAlreadySearchedCep(true);

        return dataAddress;
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup } = event;

        let field = { ...cloneObject(dataForm[id]), value, lookup, unmaskedValue, error: '' };

        const city = cloneObject(dataForm.city);

        if (id === 'uf') {
            const municipios = await handleChangeState(value);

            city.options = municipios;
            city.value = '';
            city.lookup = '';
        }

        let dataAddress = {};

        if (id === 'cep' && unmaskedValue.length === 8 && unmaskedValue !== dataForm.cep.value) {
            dataAddress = (await handleChangeCep(event)) || {};

            if (dataAddress.uf.value) document.getElementById('addressNumber').focus();

            const municipios = await handleChangeState(dataAddress.uf.value);

            dataAddress.city.options = municipios;

            field = dataAddress.cep;
        }

        setDataForm({
            ...dataForm,
            city,
            ...dataAddress,
            [id]: field,
        });
    }

    return (
        <>
            <Accordion title="Endereço de correspondência" hasCollapse={false}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Input
                            field={{
                                ...dataForm.cep,
                                disabled: cepLoading,
                                loading: cepLoading,
                                icon: { name: 'search', type: 'round' },
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </Grid>

                    <Grid item xs={12} md={6} />

                    <Grid item xs={12} md={6}>
                        <Input
                            field={{
                                ...dataForm.address,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.addressNumber} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.complement} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input
                            field={{
                                ...dataForm.hood,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Select
                            field={{
                                ...dataForm.uf,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Select
                            field={{
                                ...dataForm.city,
                                disabled: !alreadySearchedCep,
                            }}
                            onBlur={handleInputBlur}
                            onChange={handleChangeInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.phone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.phone2} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.cellphone} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.email} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Input field={dataForm.email2} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    </Grid>
                </Grid>
            </Accordion>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                <Button id="backStep" type="secondary" style={{ marginRight: '24px' }} onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button id="continueStep" type="primary" style={{ marginRight: '12px' }}>
                    Salvar alterações
                </Button>
            </Grid>
        </>
    );
}

export default EditarEndereco;
